<template>
    <select class="lang-select" v-model="selected" @change="changeLanguage" v-if="languages && languages.length > 1">
        <option v-for="language in languages" :key="language" :value="language" >{{ language.toUpperCase() }}</option>
    </select>
</template>

<script>
import { mapGetters } from 'vuex';
import langPool from '@/content/language';

export default {
    created() {
        if (!this.locale || this.languages.length < 2) {
            this.$store.commit('localisation/setLocale', this.$root.$i18n.locale);
        }
        if (!this.cmsLocaleKey || this.languages.length < 2) {
            this.$store.commit('localisation/setCmsLocaleKey', process.env.VUE_APP_BUTTER_CMS_LOCALE);
        }
    },
    computed: {
        ...mapGetters({
            locale: 'localisation/getSelectedLocale',
            cmsLocaleKey: 'localisation/getCmsLocaleKey',
        }),
    },
    data() {
        return {
            languages: process.env.VUE_APP_SUPPORTED_LANGUAGES.split(','),
            selected: this.$root.$i18n.locale.split('-')[1],
            country: process.env.VUE_APP_COUNTRY_ISO.toLowerCase(),
        };
    },
    methods: {
        changeLanguage() {
            const updatedLocale = `${this.country}-${this.selected}`;
            this.$root.$i18n.locale = updatedLocale;
            this.$store.commit('localisation/setLocale', updatedLocale);
            this.$moment.locale(langPool[this.selected].momentKey, {
                week: {
                    dow: 1,
                },
            });
            const butterCmsLocale = this.selected === 'en' ? 'en-eu' : updatedLocale;
            this.$store.commit('localisation/setCmsLocaleKey', butterCmsLocale);
        },
    },
};
</script>
<style lang="scss" scoped>
.lang-select{
    margin: 0.5rem;
    background: none;

    &:focus{
        outline: none;
    }
}
</style>
